import GroupQuote from './GroupQuote';
import AchieversQuote from './AchieversQuote';
import { depositModesForPlanTypeUntranslated } from "../Utils/PlanUtils";
import { useEffect, useState } from "react";
import QuotePDFViewer from "./QuotePDFViewer";
import { PLAN_TYPE_IDS } from "../Utils/PlanUtils";
import SelfInitiatedQuote from "./SelfInitiatedQuote";
import IllustrationDisclosure from "./IllustrationDisclosure";
import { useTranslation } from "react-i18next";

const QuoteAllModes = ({ state, showAllSimultaneously, setCompletedQuoteImages, setCompletedPageCount, backFunction, fullScale }) => {
    const allModes = depositModesForPlanTypeUntranslated(state.plan.planTypeID);
    const [selectedMode, setSelectedMode] = useState(null);
    const [quoteImages, setQuoteImages] = useState([]);
    const [quoteImage, setQuoteImage] = useState(null);
    const [generatePDF, setGeneratePDF] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (selectedMode) { return; }
        setSelectedMode(reorderedModes(state)[0].value);
        if (quoteImages.length === 0) {
            setQuoteImages(new Array(reorderedModes(state).length + 1).fill(null));
        }
    }, [allModes]);

    useEffect(() => {
        if (!quoteImages.includes(null)) {
            //If we have filled all images, we can notify the parent
            if (setCompletedQuoteImages) {
                setCompletedQuoteImages(quoteImages);
            }
        }

        if (setCompletedPageCount) {
            setCompletedPageCount(quoteImages.filter(image => image).length);
        }
    }, [quoteImages]);

    const convertStateToMode = (state, mode) => {
        return {
            ...state,
            plan: {
                ...state.plan,
                depositMode: mode
            }
        }
    }

    const _setQuoteImage = (mode) => (image) => {
        console.log('_setQuoteImage');
        if (!setCompletedQuoteImages) { return; }
        setQuoteImages((prevState) => {
            const newImages = [...prevState];
            //Disclosure is always the last page
            if (mode === 'disclosure') {
                newImages[newImages.length - 1] = image;
            } else {
                newImages[allModes.findIndex(m => m.value === mode)] = image;
            }

            return newImages;
        });
    }

    //returns a new ordering of the modes, with the first one being the one selected in the original state
    const reorderedModes = (state) => {
        let ret = [allModes.find(m => m.value === state.plan.depositMode)];
        allModes.filter(m => m.value !== state.plan.depositMode).forEach(m => ret.push(m));
        return ret;
    }

    const allQuoteComponents = (state) => {

        const depositCode = state.plan.depositCode;
        return (
            <div>
                {reorderedModes(state).map((mode, index) => {
                    if (showAllSimultaneously || mode.value === selectedMode) {
                        if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
                            return (
                                <GroupQuote
                                    state={convertStateToMode(state, mode.value)}
                                    page={index + 1}
                                    totalPages={allModes.length + 1}
                                    setQuoteImage={_setQuoteImage(mode.value)}
                                    fullScale={fullScale}
                                />
                            );
                        }
                        if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
                            return (
                                <AchieversQuote
                                    state={convertStateToMode(state, mode.value)}
                                    page={index + 1}
                                    totalPages={allModes.length + 1}
                                    setQuoteImage={_setQuoteImage(mode.value)}
                                    fullScale={fullScale}
                                />
                            );
                        }
                        if (state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
                            return (
                                <SelfInitiatedQuote
                                    state={convertStateToMode(state, mode.value)}
                                    page={index + 1}
                                    totalPages={allModes.length + 1}
                                    setQuoteImage={_setQuoteImage(mode.value)}
                                    fullScale={fullScale}
                                />
                            );
                        }
                    }
                    return null;
                })}

                {(showAllSimultaneously || selectedMode === 'disclosure') &&
                    <IllustrationDisclosure
                        state={state}
                        page={allModes.length + 1}
                        totalPages={allModes.length + 1}
                        hideSignatures={true}
                        setQuoteImage={_setQuoteImage('disclosure')}
                    />
                }
            </div>
        );
    }

    if (!generatePDF) {
        return (
            <div>
                {!showAllSimultaneously &&
                    <div className={'mode-tabs'}>
                        {reorderedModes(state).map((mode, index) => {
                            return (
                                <span>
                                    <span className={'clickable mode-selector'}
                                        onClick={() => setSelectedMode(mode.value)}>
                                        {mode.label.split(' - ').map(part => t(part.trim())).join(' - ')}
                                    </span>
                                    -
                                </span>
                            )
                        })}

                        <span className={'clickable mode-selector'}
                            onClick={() => {
                                setSelectedMode('disclosure');
                            }}>
                            Disclosure
                        </span>
                        -
                        <span className={'clickable mode-selector'}
                            onClick={() => {
                                setGeneratePDF(true);
                            }}>
                            PDF
                        </span>

                        {backFunction &&
                            <span>
                                -
                                <span className={'clickable mode-selector'}
                                    onClick={backFunction}>
                                    Back
                                </span>
                            </span>
                        }
                    </div>
                }
                {allQuoteComponents(state)}
            </div>
        )
    } else {
        return <QuotePDFViewer state={state} />
    }

}

export default QuoteAllModes;